// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__75nVK","row":"ProcedureTreatmentSummary_row__1rrBO"};